import { Vector3 } from 'three';

export class CameraInstructions {
  target: Vector3;
  position: Vector3;

  constructor(target: Vector3, position: Vector3) {
    this.target = target;
    this.position = position;
  }
}
